import AddressSearch from "@components/address/AddressSearch";
import LabelWithInput from "@components/input/LabelWithInput";

export const Address = ({ required }: { required?: boolean }) => {
  return (
    <>
      <LabelWithInput label={"주소"} required={required}>
        <AddressSearch />
      </LabelWithInput>
    </>
  );
};
